<template>
    <div>
        <span class="data-label">
            <div class="ellipsis">{{ forceLabel ? forceLabel : label }}</div>
            <i
                v-if="useFavorite"
                :class="['blue ml-2 fs-2 cpointer data-label-icon-toggle', isFavoriteClass]"
                @click.prevent="toggleFavorite"
            ></i>
            <i
                v-if="canRemoveFavorite"
                class="icon-close primary-50 ml-2 fs-2 cpointer"
                @click.prevent="toggleFavorite"
            ></i>
        </span>
        <span class="data-value copy-element">
            <a
                :href="phonecallProtocol + ':' + value.replace(/[^\+\d]/g, '')"
                :class="['black-link semibold', canRemoveFavoriteClass]"
            >
                {{ value }}
            </a>
            <SaasClipboard v-if="value" :data="value" />
        </span>
    </div>
</template>

<script>
import SaasClipboard from 'vcomponents/utilities/SaasClipboard.vue';
import FavoriteHeaderMixins from '../../../../mixins/FavoriteHeaderMixins';
import DataValueMixin from '../../../../mixins/DataValueMixins';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('corp');

export default {
    components: {
        SaasClipboard,
    },
    mixins: [FavoriteHeaderMixins, DataValueMixin],
    computed: {
        ...mapState(['phonecallProtocol']),
    },
};
</script>

<style scoped>
.data-label {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
